import { defineComponent as i, ref as s, onMounted as a, onUnmounted as c, createElementBlock as u, openBlock as d, normalizeClass as f, renderSlot as m } from "vue";
const w = /* @__PURE__ */ i({
  __name: "LinkList",
  setup(v) {
    const e = s(), r = s(!1), n = () => {
      if (!e.value)
        return;
      const { scrollWidth: o, clientWidth: l } = e.value;
      r.value = o > l;
    };
    let t = null;
    return a(() => {
      n(), window.addEventListener("resize", n), e.value && (t = new MutationObserver(() => {
        n();
      }), t.observe(e.value, {
        childList: !0,
        subtree: !0
      }));
    }), c(() => {
      window.removeEventListener("resize", n), t && (t.disconnect(), t = null);
    }), (o, l) => (d(), u("div", {
      ref_key: "containerRef",
      ref: e,
      class: f([{ "icons-only": r.value }, "custom-scroll mb-3 flex h-auto min-h-8 max-w-full items-center gap-2 overflow-x-auto text-xs whitespace-nowrap xl:mb-1.5"])
    }, [
      m(o.$slots, "default", {}, void 0, !0)
    ], 2));
  }
});
export {
  w as default
};
